import * as React from "react";
import classnames from "classnames";
import moment from "moment";

import { TableRow, TableData } from "./flux";
import { Polyglot } from "../../../../polyglot";
import { NonIsolatedPremise } from "../../NonIsolatedPremise";

const styles = require('./Table.scss');
const tableStyles = require('../../../../components/Table.scss');

interface Props
{
    polyglot: Polyglot;
    data: TableData;
    className?: string;

    onClick?: (row: TableRow) => void;
    onHeader?: (thead: HTMLTableSectionElement) => void;
}

const dotTypeClass = {
    square: styles.SquareIcon,
    circle: styles.CircleIcon
};
const severityClass = {
    red: styles.Red,
    yellow: styles.Yellow,
};
export class TableView extends React.Component<Props>
{
    render()
    {
        const {
            polyglot, data,
            onHeader,
        } = this.props;
        const { headers, rows } = data;

        return (
            <table className={classnames('table table-striped table-bordered table-hover', tableStyles.StickyTable, this.props.className)}>
                <thead ref={e => onHeader && onHeader(e)}>
                    <tr>
                        <th>{polyglot.t('sensors_data.label_time')}:</th>
                        { headers.map((header, idx) => <th key={idx} className='text-center'>{header}</th>) }
                        <NonIsolatedPremise>
                            <th>{polyglot.t('sensors_data.btn_map')}</th>
                        </NonIsolatedPremise>
                    </tr>
                </thead>
                <tbody onClick={e => this.onRowClicked(this.getRowIdx(e), rows)}>
                {
                    rows.map((row, rowIdx) => (
                        <tr key={rowIdx} data-row={rowIdx}>
                            <td>
                                {
                                    moment(row.dateTimeReceivedOn).year() > 2017 &&
                                    <span className="tooltip-message" data-toggle="tooltip" data-placement="top" title={`Received At: ${moment(row.dateTimeReceivedOn).format('YYYY-MM-DD HH:mm:ss')}`}>
                                      {moment(row.date).format('YYYY-MM-DD HH:mm:ss')}
                                    </span>
                                }
                                {
                                    moment(row.dateTimeReceivedOn).year() < 2017 &&
                                        moment(row.date).format('YYYY-MM-DD HH:mm:ss')
                                }
                            </td>
                            { row.values.map((v, i) => v ? <td key={i} className={classnames(dotTypeClass[v.dotType], severityClass[v.severity])}>{v.value} <span/></td> : <td key={i} />) }
                            <NonIsolatedPremise>
                                <td>{row.lat && row.lat ? '+' : '-'}</td>
                            </NonIsolatedPremise>
                        </tr>
                    ))
                }
                </tbody>
            </table>

        );
    }

    private getRowIdx(e: React.MouseEvent<HTMLTableSectionElement>)
    {
        const td = e.target as HTMLTableCellElement;
        const tr = td.parentElement;
        return parseInt(tr.dataset.row, 10);
    }

    private onRowClicked(rowIdx: number, tableRows: TableRow[])
    {
        const { onClick } = this.props;
        if(onClick) {
            onClick(tableRows[rowIdx]);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/SensorsData/Table.tsx